import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'li';
}
const animation = {
  initial: {
    opacity: 0,
    y: 18
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    amount: 0.15
  } as const,
  transition: {
    duration: 0.5,
    ease: 'easeOut' as const
  }
};
export function Reveal({
  children,
  delay = 0,
  className,
  as = 'div'
}: RevealProps) {
  const Component = as === 'li' ? motion.li : motion.div;
  return <Component className={className} initial={animation.initial} whileInView={animation.whileInView} viewport={animation.viewport} transition={{
    ...animation.transition,
    delay
  }} data-id="element-58" data-mp="2nt36ubu9t9ck">
      {children}
    </Component>;
}